import { memo } from 'react';

import { Tooltip } from '@material-ui/core';

import { useEvaluationContextField } from '@spotify/plugin-confidence-targeting-react';

import { Expression } from '../Expression';

export const FieldName = memo(({ field }: { field: string }) => {
  const fieldOverride = useEvaluationContextField(field);
  return (
    <Tooltip title={field} arrow enterDelay={700}>
      <Expression.Property>
        {fieldOverride?.displayName || field}
      </Expression.Property>
    </Tooltip>
  );
});

FieldName.displayName = 'FieldName';
